import React, { FC } from 'react'
import { NeoSelectConnectedProps, NeoSelectConnected } from 'LibNeo'
import { useAppDispatch } from 'Src/hooks'
import { useSelector } from 'react-redux'
import { RequestParams, ShortDataModel } from 'Models'
import { KEYS, selectSlice, selectSelectors, FIELDS, PARAMS_DATA } from 'Modules/Select'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import { AppState } from 'Store'

const actions = {
	getItems: selectSlice.actions.getAllByKey,
	clearItems: selectSlice.actions.clearAllByKey,
	setRequestParams: selectSlice.actions.setRequestParamsByKey,
}
export const SelectComponent: FC<
	Partial<NeoSelectConnectedProps<ShortDataModel> & { keySelect: KEYS }>
> = (props) => {
	const key = props.keySelect
	const { getItems, clearItems, setRequestParams } = useAppDispatch(actions)
	const data = useSelector((state: AppState) => selectSelectors.getDataByKey(state, key))
	const params = useSelector((state: AppState) => selectSelectors.getParamsByKey(state, key))
	useEffectOnce(() => {
		if (!props?.paramsData && !PARAMS_DATA[key])
			getItems({ params: new RequestParams(), options: {}, key })
	})
	return (
		<NeoSelectConnected
			{...props}
			paramsData={props?.paramsData ?? PARAMS_DATA[key] ?? null}
			fieldName={props?.fieldName ?? FIELDS[key]}
			getItems={(params, options, callback) => {
				getItems({
					params,
					options,
					callback,
					key,
				})
			}}
			clearItems={() => clearItems(key)}
			setRequestParams={(params) => {
				setRequestParams({
					params,
					key,
				})
			}}
			data={props?.data ?? data}
			params={params}
		/>
	)
}

export default SelectComponent
